import React from 'react'
import {Link, useLocation} from "react-router-dom"
import Nav from '../nav/Nav'
import styles from './HeaderNav.module.css'
import RouteUtils from "../../../../domain/utils/RouteUtils"
import {NavItem} from "../nav/NavItem"
import LangSwitcher from "../lang_switcher/LangSwitcher"


/**
 *  Шапка сайта с Навигацией
 *
 *  @param routes - список путей в навигацию
 *  @param basePath - ссылка на корневую страницу
 *  @returns {JSX.Element}
 * @constructor
 */
export default function HeaderNav({ routes=[], basePath='' }){

    // Начальные данные
    const location = useLocation()
    const parentPath = RouteUtils.pathToParent(basePath)
    const links = NavItem.listFromAppRoutes(routes)

    console.log({
        location:   location,
        homePath:   basePath,
        parentPath: parentPath,
        routes:     routes,
        links:      links,
    })

    return (
        <div className={styles.container + ' wrap'}>
            <div><Link to="/" className={styles.logo}/></div>
            <div>{<Nav links={links}/>}</div>
            <div><LangSwitcher /></div>
        </div>
    )

}


